<template>
  <div class="app-container medal">
    <div class="medal-filter">
      <el-row>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-input class="medal-filter-value" v-model.trim="filter.name" @keyup.enter.native="clickFilterBtn" placeholder="勋章名称" clearable size="small" suffix-icon="el-icon-search"></el-input>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-select class="medal-filter-value" v-model="filter.medalRule" @keyup.enter.native="clickFilterBtn" placeholder="勋章规则" clearable size="small">
              <el-option
                v-for="(item, index) in medalRules"
                :key="index"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-input class="medal-filter-value" v-model.trim="filter.gradeName" @keyup.enter.native="clickFilterBtn" placeholder="勋章等级名称" clearable size="small" suffix-icon="el-icon-search"></el-input>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-select class="medal-filter-value" placeholder="是否已启用" v-model="filter.isActive" clearable size="small">
              <el-option
                v-for="item in activeMedalOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-select class="medal-filter-value" v-model="filter.medalGroup" @keyup.enter.native="clickFilterBtn" placeholder="勋章分组" clearable size="small">
              <el-option
                v-for="(item, index) in medalGroup"
                :key="index"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="6"></el-col>
        <el-col :span="6"></el-col>
        <el-col :span="6">
          <div>
            <el-button class="medal-filter-search" size="small" @click="clickFilterBtn">立即筛选</el-button>
            <el-button class="medal-filter-reset" size="small" @click="clickClearBtn">清除条件</el-button>
          </div>
        </el-col>
      </el-row>
    </div>
    <basic-container class="medal-container">
      <div class="medal-body">
        <div class="medal-body-right" v-loading="isUploading">
          <div class="medal-body-right-operation">
            <el-button v-if="medal_add" 
                       type="primary" 
                       size="small" 
                       @click="handleCreate" 
                       icon="el-icon-plus">新增
            </el-button>
            <el-button v-if="permissions.medal_cache_sync"
                       type="primary" 
                       size="small"
                       @click="handleSyncCache"
                       icon="el-icon-refresh" >同步
            </el-button>
          </div>
          <div class="medal-body-right-body">
            <avue-crud :table-loading="listLoading" 
                       :data="list" 
                       :option="option"
                       ref="crud"
                       v-model="form" 
                       :page.sync="page"
                       @on-load="onLoad" 
                       @select="handleSelect" 
                       @select-all="handleSelectAll">
              <template slot="name" slot-scope="scope">
                <div class="preview">
                  <div class="lit-image" v-if="scope.row.litUrl" v-viewer>
                    <img :src="scope.row.litUrl">
                  </div>
                  <a href="javascript:void(0);" @click="handleDetail(scope.row,scope.index);" class="medal-container-button">
                     {{scope.row.name}}
                  </a>
                </div>
              </template>
              <template slot="menu" slot-scope="scope" width=100>
                <el-button size="mini"
                           type="text"
                           icon="el-icon-edit"
                           v-if="permissions.medal_edit"
                           @click="handleUpdate(scope.row,scope.index)">编辑
                </el-button>
                <el-button size="mini"
                           type="text"
                           v-if="permissions.medal_issue"
                           @click="handleIssue(scope.row,scope.index)">发放勋章
                </el-button>
                <el-button size="mini"
                           type="text"
                           icon="el-icon-close"
                           v-if="permissions.medal_down && scope.row.isActive"
                           @click="handleDown(scope.row,scope.index)">禁用
                </el-button>
                <el-button size="mini"
                           type="text"
                           icon="el-icon-check"
                           v-if="permissions.medal_up && !scope.row.isActive"
                           @click="handleUp(scope.row,scope.index)">启用
                </el-button>
              </template>
              <template slot="groupIdForm">
                <el-select v-model="form.groupId" size="medium">
                  <el-option v-for="item in medalGroup"
                             :key="item.id"
                             :label="item.groupName"
                             :value="item.id">
                  </el-option>
                </el-select>
              </template>
            </avue-crud>
          </div>
        </div>
      </div>
    </basic-container>
    <el-dialog title="发放勋章"
               :visible.sync="issueMedalDialog"
               width="40%"
               class="handle-dialog">
      <el-form ref="issueFrom" :model="issueFrom" :rules="unionRules">
        <el-form-item prop="unionId">
          <el-label >员工号:</el-label>
          <el-input type="text" placeholder="请输入需发放勋章的员工号" @keyup.enter.native="selectMemberInfo" v-model="issueFrom.unionId"></el-input>
          <el-button type="primary" @click="selectMemberInfo">查找</el-button>
        </el-form-item>
        <el-row v-if="memberInfo.unionId">
          <el-col>员工号:{{memberInfo.unionId}}</el-col>
        </el-row>
        <el-row v-if="memberInfo.nickname">
          <el-col>昵 称:{{memberInfo.nickname}}</el-col>
        </el-row>
        <el-row v-if="memberInfo.realname">
          <el-col>用户名:{{memberInfo.realname}}</el-col>
        </el-row>
        <div class="handle-dialog-footer">
          <el-button type="primary" class="handle-dialog-footer-save" @click="issue">确定</el-button>
          <el-button class="handle-dialog-footer-cancel" @click="closeDialogHandleIssue">取消</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { medalRules, tableOptions } from '@/const/crud/medal/medal'
import { getMedalGroupList, getMedalList, getMemberInfo, issueMedal, enableMedal, disableMedal, syncMedalCache } from '@/api/medal/medal'
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      medalGroup: [],
      medalRules,
      activeMedalOptions: [
        { label: '是', value: 1 },
        { label: '否', value: 0 },
      ],
      page: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      },
      filter: {
        medalGroup: '',
        name: '',
        medalRule: '',
        gradeName: '',
        isActive: '',
        sortField: '',
        sortPolicy: '',
      },
      listLoading: true,
      isUploading: false,
      issueMedalDialog: false,
      memberInfo: {},
      issueFrom: {
        unionId: '',
        memberId: '',
        medalId: '',
      },
      list: [],
      option:tableOptions,
      form: {},
      unionRules: {
        unionId: {  required: true,message: '员工号不能为空',trigger: 'blur' }
      }
    }
  },
  computed: {
      ...mapGetters(["permissions"])
  },
  activated () {
    this.basicGetMedalList();
  },
  created() {
    this.loadMedalGroup();
    this.medal_add = this.permissions["medal_add"];
    this.medal_edit = this.permissions["medal_edit"];
    this.medal_del = this.permissions["medal_del"];
    this.medal_cache_sync = this.permissions["medal_cache_sync"];
    this.medal_up = this.permissions["medal_up"];
    this.medal_down = this.permissions["medal_down"];
    this.medal_issue = this.permissions["medal_issue"];
  },
  methods: {
    async loadMedalGroup(){
      const response = await getMedalGroupList();
      this.medalGroup = [{id: '', name: '全部'}].concat(response.data.data);
      this.medalGroup = [{id: -1, name: '未分组'}].concat(this.medalGroup);
    },
    async basicGetMedalList() {
      this.listLoading = true;
      const params = {};
      params.size = this.page.pageSize;
      params.current = this.page.currentPage;
      params.name = this.filter.name
      params.medalGroup = this.filter.medalGroup;
      params.medalRule = this.filter.medalRule;
      params.gradeName = this.filter.gradeName;
      params.isActive = this.filter.isActive;
      if (this.filter.sortField) {
        params.sortField = this.filter.sortField;
      } else {
        params.sortField = 'sort';
      }
      if (this.filter.sortPolicy) {
        params.sortPolicy = this.filter.sortPolicy;
      } else {
        params.sortPolicy = 'asc';
      }
      const response = await getMedalList(params);
      this.list = this.formatData(response.data.data.records);
      this.page.total = response.data.data.total;
      this.listLoading = false;
    },
    formatData(records) {
        if (records && records.length > 0) {
          records.forEach(function(record, index) {
            if(!record.grade) {
              record.grade = "--"
            }
            if(!record.gradeName) {
              record.gradeName = "--"
            }
            if (!record.condition) {
              record.condition = "--"
            }
            if (!record.medalRule) {
              record.medalRule = "--"
            } else {
              record.medalRule = medalRules.find(item => item.value === record.medalRule).label;
            }
            if (!record.groupName) {
              record.groupName = "未分组"
            }
          })
        }
        return records
      },
    onLoad(page) {
      this.page.pageSize = page.pageSize;
      this.page.currentPage = page.currentPage;
      this.basicGetMedalList(page);
    },
    handleSelect (selection, row) {
      this.selectedList = selection;
    },
    handleSelectAll (selection) {
      this.selectedList = selection;
    },
    handleCreate() {
      this.$router.push({ path: '/reward/medal/add' });
    },
    handleUpdate(row, index) {
      if (row.id){
        this.$router.push({
          path: `/reward/medal/edit/${row.id}`
        })
      } else {
        this.$message({
          showClose: true,
          message: '该勋章不存在',
          type: 'warning'
        })
      }
    },
    handleDetail(row, index) {
        if (row.id){
          this.$router.push({
            path: `/reward/medal/detail/${row.id}`
          })
        } else {
          this.$message({
            showClose: true,
            message: '该勋章不存在',
            type: 'warning'
          })
        }
      },
    handleIssue(row,index) {
      this.issueMedalDialog = true,
      this.issueFrom.medalId = row.id;
    },
    selectMemberInfo() {
      this.$refs.issueFrom.validate((valid) => {
        if (!valid) return;
        this.memberInfo = '';
        getMemberInfo(this.issueFrom.unionId).then(response => {
          let data = response.data
          if (response.status == 200) {
            this.memberInfo = data.data;
            this.issueFrom.memberId = this.memberInfo.memberId;
          } else {
            this.$message({
              showClose: true,
              message: '未获取到用户信息',
              type: 'error'
            });
          }
        })
      })
    },
    issue() {
      this.$refs.issueFrom.validate((valid) => {
        if (!valid) return;
        if (!this.memberInfo.memberId) {
          this.$message({
            showClose: true,
            message: '未获取到发放对象',
            type: 'error'
          });
          return;
        }
        issueMedal(this.issueFrom).then(() => {
          this.page.currentPage = 1;
          this.basicGetMedalList();
          this.issueMedalDialog = false;
          this.issueFrom.unionId = '';
          this.memberInfo = '';
          this.$notify({
            title: '成功',
            message: '发放成功',
            type: 'success',
            duration: 2000
          })
        })
      })
    },
    handleUp(row) {
      var _this = this
      this.$confirm('是否确认启用名为"' + row.name + '"的勋章?', '启用', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        return enableMedal(row.id)
      }).then(() => {
        this.basicGetMedalList();
        _this.$message({
          showClose: true,
          message: '启用成功',
          type: 'success'
        })
      }).catch(function () {
      })
    },
    handleDown(row) {
      var _this = this
      this.$confirm('是否确认禁用名为"' + row.name + '"的勋章?', '禁用', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        return disableMedal(row.id)
      }).then(() => {
        this.basicGetMedalList();
        _this.$message({
          showClose: true,
          message: '禁用成功',
          type: 'success'
        })
      }).catch(function () {
      })
    },
    closeDialogHandleIssue() {
      this.issueMedalDialog = false;
      this.issueFrom.unionId = '';
      this.memberInfo = '';
      this.$refs.issueFrom.clearValidate();
    },
    handleTypeSelect (index) {
      const searchType = (index === '0' ? null : index);
      if (searchType === this.filter.medalGroup) {
        return;
      }
      this.filter.medalGroup = searchType;
      this.page.currentPage = 1;
      this.basicGetMedalList();
    },
    clickClearBtn () {
      this.filter.name = '';
      this.filter.gradeName = '';
      this.filter.medalRule = '';
      this.filter.isActive = '';
      this.filter.medalGroup = '';
      this.page.currentPage = 1;
      this.basicGetMedalList();
    },
    clickFilterBtn () {
      this.page.currentPage = 1;
      this.basicGetMedalList();
    },
    handleSyncCache() {
      var _this = this;
      _this.$confirm('请确认是否需要同步勋章缓存？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(function () {
        return syncMedalCache();
      }).then(() => {
        _this.$message({
          showClose: true,
          message: '同步成功',
          type: 'success',
        });
      }).catch(function (err) {
        if (err == 'cancel') {
          return;
        }
        _this.$message({
          showClose: true,
          message: '同步失败',
          type: 'error',
        });
      });
    },
  }
}
</script>

<style lang="scss" scoped>
.medal {
  &-filter {
    margin: 0 10px;
    /deep/ .el-input__inner {
      border: none;
      font-size: 14px;
    }
    .el-row {
      width: 95%;
    }
    &-value {
      width: calc(100% - 12px) !important;
    }
    &-reset {
      float: right;
      margin-right: 8px;
    }
    &-search {
      float: right;
      margin-right: 10px;
      border-color: #5383f3;
      color: #5383f3;
    }
  }

  &-container {
    &-button {
      color: #409EFF;
      font-size: 14px;
      text-align: center;
      font-weight: 500;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 170px;
      text-align: left;
    }
  }
}
.medal-header {
  display: flex;
  justify-content: space-between;
  padding: 0 10px;
  &-filter {
    display: flex;
    justify-content: space-between;

    .el-button+ .el-button {
      margin: 0px;
    }
    &-search {
      margin-left: 8px;
      border-color: #5383f3;
      color: #5383f3;
    }
    &-reset {
      margin-left: 20px;
      margin-right: 8px;
    }
  }
}
 ::v-deep.el-menu {
    background-color: transparent;
    .el-menu-item {
      color: #3b3b3b;
      height: 40px;
      border-radius: 4px;
      line-height: 40px;
    }
    .el-menu-item:focus,
    .el-menu-item:hover {
      color: #409EFF;
      .menu-btn {
        visibility: visible;
      }
    }
    .menu-btn {
      margin: 0;
      padding: 0;
      visibility: hidden;
      float: right;
      padding-top: 10px;
    }
 }
.preview {
  display: flex;
  align-items: center;
  .lit-image {
    display: flex;
    width: fit-content;
    margin-right: 12px;
    cursor: pointer;
    img {
      width: 40px;
      height: 40px;
      object-fit: cover;
      max-width: 100%;
    }
  }
}
.handle-dialog {
  display: flex;
  flex-direction: column;
  &-footer{
    display: flex;
    flex-direction: row;
    padding: 50px 0px;
    &-save {
      padding: 8px 12px;
      position: absolute;
      right: 90px;
    }
    &-cancel {
      padding: 8px 12px;
      position: absolute;
      right: 10px;
      margin-right: 10px;
    }
  }
}
</style>
